import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button, Checkbox, Flex, Grid, Textarea, Title, Icon } from '@siteground/styleguide';

import { sendFeedback } from '../../../app-communication/actions/from-client-frontend';
import { ChatLayout } from '../../../components/chat-layout';
import { HeaderBackButton } from '../../../components/header-back-button';
import { PresentationLayout } from '../../../components/presentation-layout';

const Feedback = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [feedback, setFeedback] = React.useState('');
  const [isToSChecked, setIsToSChecked] = React.useState(false);
  const [shouldShowFeedbackForm, setShouldShowFeedbackForm] = React.useState(true);
  const [error, setError] = React.useState(null);

  return (
    <ChatLayout
      header={<HeaderBackButton />}
      content={
        shouldShowFeedbackForm ? (
          <Grid justifyItems="center">
            <Title level="4" align="center">
              {intl.formatMessage({ id: 'translate.operator.feedback.title' })}
            </Title>

            <Textarea
              autoFocus
              rows="10"
              label={intl.formatMessage({ id: 'translate.operator.feedback.textarea.label' })}
              value={feedback}
              state={error ? 'error' : undefined}
              validationMessage={error ? intl.formatMessage({ id: error }) : undefined}
              onChange={(event) => setFeedback(event.target.value)}
            />

            <Checkbox size="small" checked={isToSChecked} onChange={(event) => setIsToSChecked(event.target.checked)}>
              {intl.formatMessage({ id: 'translate.operator.feedback.tos' })}
            </Checkbox>

            <Flex justify="center" style={{ width: '100%' }}>
              <Button
                color="primary"
                onClick={() =>
                  dispatch(
                    sendFeedback({
                      review: feedback,
                      agree_publish: Number(isToSChecked),
                      onComplete: () => setShouldShowFeedbackForm(false),
                      onFailure: (error) => setError(error.message)
                    })
                  )
                }
              >
                {intl.formatMessage({ id: 'translate.generic.submit' })}
              </Button>
            </Flex>
          </Grid>
        ) : (
          <PresentationLayout
            title={intl.formatMessage({ id: 'translate.thank.you.title.good' })}
            message={intl.formatMessage({ id: 'translate.thank.you.message.good' })}
            icon={<Icon name="illustration-thumbs-up" width="138" height="97" multicolor />}
          />
        )
      }
    />
  );
};

export default Feedback;
